import { Box, useTheme } from "@mui/material";
import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

const PageContainer = ({ children }: Props) => {
  const theme = useTheme();

  const container: React.CSSProperties = {
    minHeight: "90vh",
    border: `1px solid ${theme.palette.tertiary.light}`,
    marginBottom: "3rem",
  };

  return <Box sx={container}>{children}</Box>;
};

export default PageContainer;
